import request, { IWorkspaceResponse } from '../http/Xrequest '

// 部门树结构列表
export const getDeptList = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/system/dept/deptTreeWithNoAuth'
  const result = await request.get(url)
  return result.data
}

// 查询项目巡检区域列表
export const getCheckInspectionAreasList = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/workspaces/inspection-area/tree'
  const result = await request.get(url)
  return result.data
}
